import { useAuth } from "react-oidc-context";

export function useAccessToken(): string | undefined {
    const auth = useAuth();
    return auth.user?.access_token;
}
